import type { Epic } from 'Flux/index.js'
import type { IUser } from 'Model/index.js'
import { authenticationSlice } from 'Flux/Slice/Authentication/AuthenticationSlice.js'
import { isOrganizationOverrideActive } from 'Model/User/organizationOverride.js'
import { EMPTY } from 'rxjs'
import { catchError, filter, ignoreElements, map, mergeMap } from 'rxjs/operators'

const attemptedOrgIds = new Set<string>()

/* An overridden org has the target's plan id, which is absent for any customer without a
 * subscription -- and the bootstrap would then write the operator's Chargebee state onto them. */
function shouldSyncChargebeeState(user?: IUser): user is IUser {
  return !!user && !user.org.chargebeePlanId && !attemptedOrgIds.has(user.org.id) && !isOrganizationOverrideActive(user)
}

export const SyncChargebeeStateEpic: Epic = (action$, _, { AuthenticationRepository, [authenticationSlice.name]: authentication }) =>
  action$.pipe(
    filter((action) => authentication.loginSuccess.match(action) || authentication.fetchUserIfPresentSuccess.match(action)),
    map((action) => action.payload.user),
    filter(shouldSyncChargebeeState),
    mergeMap((user) => {
      attemptedOrgIds.add(user.org.id)
      return AuthenticationRepository.refreshChargebeeSession().pipe(
        ignoreElements(),
        catchError((error) => {
          attemptedOrgIds.delete(user.org.id)
          console.warn('Chargebee session bootstrap failed', error)
          return EMPTY
        })
      )
    })
  )
